import React from "react";
import { connect } from "react-redux";
import {
  startSetDc,
  setDcConnectivity,
  setDcNames,
  toIsoStringTillSec,
} from "../actions/dc";
import ControlBox from "./ControlBox";
import InfoBox from "./InfoBox";
import { addSeconds, format, isEqual } from "date-fns";
import "../styles/components/Header.css";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      live: true,
      historyBtnActive: false,
      speedRatio: 1,
      now: new Date(),
      playing: false,
    };
  }

  componentDidMount() {
    this.props.startSetDc();
    const performAnimation = (timestamp) => {
      this.liveDataInterval = requestAnimationFrame(performAnimation);
      if (this.start === undefined) this.start = timestamp;
      const elapsed = timestamp - this.start;

      if (elapsed % 5000 < 20) {
        // Stop the animation after 2 seconds
        this.props.startSetDc();
        this.setState(() => ({
          now: new Date(),
        }));
      }
    };

    requestAnimationFrame(performAnimation);
  }

  setLiveInterval = () => {
    if (this.state.live) {
      const performAnimation = (timestamp) => {
        this.liveDataInterval = requestAnimationFrame(performAnimation);
        if (this.start === undefined) this.start = timestamp;
        const elapsed = timestamp - this.start;

        if (elapsed % 5000 < 20) {
          // Stop the animation after 2 seconds
          this.props.startSetDc();
          this.setState(() => ({
            now: new Date(),
          }));
        }
      };

      requestAnimationFrame(performAnimation);
    } else {
      cancelAnimationFrame(this.liveDataInterval);
    }
  };

  toggleTimePicker = () => {
    this.setState(
      (prevState) => ({
        historyBtnActive: !prevState.historyBtnActive,
        live: false,
      }),
      this.setLiveInterval
    );
  };

  toggleLive = () => {
    this.setState(
      () => ({
        historyBtnActive: false,
        live: true,
      }),
      this.setLiveInterval
    );
  };

  setHistoryInterval = () => {
    cancelAnimationFrame(this.historyDataInterval);
    const performAnimation = (timestamp) => {
      this.historyDataInterval = requestAnimationFrame(performAnimation);
      if (this.start === undefined) this.start = timestamp;
      const elapsed = timestamp - this.start;

      if ((elapsed % 5000) * Math.abs(this.state.speedRatio) < 20) {
        // Stop the animation after 2 seconds
        const isPlayable = checkPlayability(
          this.props.firstOfTime,
          this.props.endOfTime,
          this.props.firstOfTimeInPlay,
          this.state.speedRatio
        );
        const time = toIsoStringTillSec(this.props.firstOfTimeInPlay);

        if (isPlayable && this.props.history && time in this.props.history) {
          const timeToAdd =
            this.state.speedRatio > 0
              ? this.props.interval
              : -this.props.interval;
          const dcNames = this.props.history[time].datacenters;
          const connections = this.props.history[time].connectivity;
          this.props.setDcNames(dcNames);
          this.props.setDcConnectivity(connections);
          this.props.getFirstOfTimeInPlay(
            addSeconds(this.props.firstOfTimeInPlay, timeToAdd)
          );
        } else if (!isPlayable) {
          cancelAnimationFrame(this.historyDataInterval);

          this.setState(() => ({
            playing: false,
          }));
        }
      }
    };

    requestAnimationFrame(performAnimation);
  };

  togglePlay = (playing) => {
    if (playing) {
      this.setHistoryInterval();
      this.setState(() => ({
        playing: true,
      }));
    } else {
      cancelAnimationFrame(this.historyDataInterval);

      this.setState(() => ({
        playing: false,
      }));
    }
  };

  getSpeedRatio = (speedRatio) => {
    this.setState(
      () => ({
        speedRatio,
      }),
      () => {
        // Set new ratio if it was in playing mode else do nothing
        if (this.state.playing) {
          this.setHistoryInterval();
        }
      }
    );
  };

  render() {
    return (
      <>
        {false && (
          <div className="header__left">
            <img src={this.props.logoSrc} alt="logo" className="header__logo" />
            <div className="header__data">
              <h1>
                <strong>DC</strong>s
              </h1>
              <p>
                by: <a href="http://www.hamravesh.com">Hamravesh</a>
              </p>
            </div>
          </div>
        )}
        <InfoBox
          interval={this.props.interval}
          speedRatio={this.state.speedRatio}
          time={
            this.state.historyBtnActive
              ? format(this.props.firstOfTimeInPlay, "YYYY-MM-DD HH:mm:ss")
              : format(this.state.now, "YYYY-MM-DD HH:mm:ss")
          }
          isLive={this.state.live}
        />
        <div className="header__right">
          <button
            type="button"
            className={`header__button ${this.state.live ? "active" : ""}`}
            onClick={this.toggleLive}
          >
            Live
          </button>
          <button
            type="button"
            className={`header__button ${this.state.live ? "" : "active"}`}
            onClick={this.toggleTimePicker}
          >
            History
          </button>
          {this.state.historyBtnActive && (
            <ControlBox
              toggleTimePicker={this.props.toggleTimePicker}
              togglePlay={this.togglePlay}
              getSpeedRatio={this.getSpeedRatio}
            />
          )}
        </div>
      </>
    );
  }
}

const checkPlayability = (firstOfRange, endOfRange, playingPos, speedRatio) => {
  if (isEqual(firstOfRange, playingPos) && speedRatio < 0) {
    return false;
  } else if (isEqual(endOfRange, playingPos) && speedRatio > 0) {
    return false;
  }
  return true;
};

const mapStateToProps = (state) => ({
  history: state.dc.history,
});

const mapDispatchToProps = (dispatch) => ({
  startSetDc: () => dispatch(startSetDc()),
  setDcConnectivity: (connections) => dispatch(setDcConnectivity(connections)),
  setDcNames: (dcs) => dispatch(setDcNames(dcs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
